<div
	class="model-container"
	*ngIf="!isLoadingLabels && !isLoadingModels && !isLoadingManufacturers && !isLoadingCiTypes && !isLoadingSubtypes">
	<div class="search" *ngIf="customInterface.id == undefined">
		<cpi-msp-table
			[header]="searchHeader"
			[body]="modelsList"
			[searchable]="true"
			[height]="'55dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			(getSelectedItem)="$event[0]['version'] === 'Manualmente' ? openForm($event[0]) : null; getReportModel($event[0]['id'])">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_novo_modelo }}</div>
		</div>
	</div>

	<ng-container *ngIf="customInterface.id != undefined">
		<div class="header-wrap">
			<span class="tab" [ngClass]="{ selected: selectedTab === 'model' }" (click)="selectedTab = 'model'">{{
				labels.lbl_geral_modelo
			}}</span>
			<span
				class="tab"
				[ngClass]="{ selected: selectedTab === 'logs' }"
				(click)="selectedTab = 'logs'"
				*ngIf="!isReportVisible && reportModelList.length > 0"
				>Logs</span
			>
		</div>
		<div class="body-wrap">
			<div class="search-container">
				<!-- <div class="table-container">
          <table>
            <thead>
              <tr>
                <th (click)="selectAll()">
                  <fa-icon [icon]="allSelected === true ? icons.faCheckSquare : icons.faSquare"></fa-icon>
                </th>
                <th>{{ labels.lbl_asset_fabricante }}</th>
                <th>{{ labels.lbl_geral_modelo }}</th>
                <th>{{ labels.lbl_asset_tipo_ci }}</th>
                <th>{{ labels.lbl_geral_subtipo }}</th>
                <th>{{ labels.lbl_geral_versao }}</th>
                <th>{{ labels.lbl_geral_ativo }}</th>
                <th>{{ labels.lbl_bulletin_actions }}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="filteredItems.length > 0; else showAll">
                <tr class="select-bond" *ngFor="let item of filteredItems; let indexItem = index">
                  <td>
                    <fa-icon *ngIf="item.version == 'Manualmente'" [icon]="item.isChecked === true ? icons.faCheckSquare : icons.faSquare" (click)="selectMultiple(item, indexItem)"></fa-icon>
                  </td>
                  <td>{{ item.name_manufacturer }}</td>
                  <td>{{ item.model }}</td>
                  <td>{{ item.label_ct }}</td>
                  <td>{{ item.label_cs }}</td>
                  <td>{{ item.version }}</td>
                  <td>{{ item.active ? labels.lbl_geral_ativo : labels.lbl_geral_desativado }}</td>
                  <td>
                    <fa-icon [icon]="item.version == 'Manualmente' ? icons.faPencil : icons.faLock" (click)="item.version === 'Manualmente' ? openForm(item) : null; getReportModel(item.id)"></fa-icon>
                  </td>
                </tr>
              </ng-container>
              <ng-template #showAll>
                <tr class="select-bond" *ngFor="let item of modelsList; let indexItem = index">
                  <td>
                    <fa-icon *ngIf="item.version == 'Manualmente'" [icon]="item.isChecked === true ? icons.faCheckSquare : icons.faSquare" (click)="selectMultiple(item, indexItem)"></fa-icon>
                  </td>
                  <td>{{ item.name_manufacturer }}</td>
                  <td>{{ item.model }}</td>
                  <td>{{ item.label_ct }}</td>
                  <td>{{ item.label_cs }}</td>
                  <td>{{ item.version }}</td>
                  <td>{{ item.active ? labels.lbl_geral_ativo : labels.lbl_geral_desativado }}</td>
                  <td>
                    <fa-icon [icon]="item.version == 'Manualmente' ? icons.faPencil : icons.faLock" (click)="item.version === 'Manualmente' ? openForm(item) : null; getReportModel(item.id)"></fa-icon>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div> -->

				<ng-container *ngIf="selectedTab === 'model'">
					<div class="form-container" *ngIf="showForm">
						<div class="dotted-input-container">
							<span>{{ labels.lbl_asset_fabricante }}*</span>
							<select id="manufacturer" name="manufacturer" [(ngModel)]="customInterface.manufacturer">
								<option [value]="''" selected disabled hidden>
									{{ labels.lbl_geral_selecione }}
								</option>
								<option *ngFor="let option of manufacturerList" [value]="option.id">{{ option.manufacturer }}</option>
							</select>
						</div>

						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_modelo }}*</span>
							<input id="model" name="model" type="text" [(ngModel)]="customInterface.model" />
						</div>

						<div class="dotted-input-container">
							<span>{{ labels.lbl_asset_tipo_ci }}*</span>
							<select
								id="type"
								name="type"
								[(ngModel)]="customInterface.type"
								(change)="getSubtypesByCiType(customInterface.type)">
								<option [value]="''" selected disabled hidden>
									{{ labels.lbl_geral_selecione }}
								</option>
								<option *ngFor="let option of ciTypeList" [value]="option.id">{{ labels[option.label] }}</option>
							</select>
						</div>

						<div class="dotted-input-container" *ngIf="showSubtypeField">
							<span>{{ labels.lbl_geral_subtipo }}</span>
							<select id="subtype" name="subtype" [(ngModel)]="customInterface.subtype">
								<option [value]="''" selected disabled hidden>
									{{ labels.lbl_geral_selecione }}
								</option>
								<option *ngFor="let option of subtypeList" [value]="option.id">{{ option.label }}</option>
							</select>
						</div>

						<div *ngIf="isLoadingSubtypes">
							<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'"> </cpi-dot-bounce-loading-effect>
						</div>

						<!-- <div class="dotted-input-container">
              <span>{{ labels.lbl_geral_versao }}</span>
              <input id="version" name="version" type="text" disabled="true" [(ngModel)]="customInterface.version"/>
            </div> -->

						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_motivo }}</span>
							<textarea
								class="textarea"
								[rows]="2"
								[value]="customInterface.message"
								(input)="customInterface.message = $event.target.value"
								>{{ customInterface.message }}</textarea
							>
						</div>

						<div class="button-container">
							<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
							<div
								class="button"
								*ngIf="customInterface.active === 1"
								(click)="desactiveSelectedModel($event)"
								#unbondAllCiButton>
								{{
									unbondAllCiButton.classList.contains('double-click')
										? labels.lbl_geral_confirmar
										: labels.lbl_geral_desativar
								}}
							</div>
							<div
								class="button"
								*ngIf="customInterface.active === 0"
								(click)="activeSelectedModel($event)"
								#unbondAllCiButton>
								{{
									unbondAllCiButton.classList.contains('double-click')
										? labels.lbl_geral_confirmar
										: labels.lbl_geral_location_ativar
								}}
							</div>
							<div class="button" type="submit" (click)="validateForm()">
								{{ labels.lbl_geral_salvar }}
							</div>
						</div>
					</div>

					<div class="search-container" *ngIf="showAlterForm">
						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_motivo }}*</span>
							<textarea
								class="textarea"
								[rows]="3"
								[value]="customInterface.message"
								(input)="customInterface.message = $event.target.value"
								>{{ customInterface.message }}</textarea
							>
						</div>
						<div class="button-container">
							<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
							<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_novo_modelo }}</div>
							<div class="button" (click)="activeSelectedModel($event)" #activateButton>
								{{
									activateButton.classList.contains('double-click')
										? labels.lbl_geral_confirmar
										: labels.lbl_geral_location_ativar
								}}
							</div>
							<div class="button" (click)="desactiveSelectedModel($event)" #deactivateButton>
								{{
									deactivateButton.classList.contains('double-click')
										? labels.lbl_geral_confirmar
										: labels.lbl_geral_desativar
								}}
							</div>
						</div>
					</div>
				</ng-container>

				<!-- Log Modelos inicio -->
				<div *ngIf="!isReportVisible && selectedTab === 'logs'">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_pesquisar }}</span>
						<input
							type="text"
							[value]="searchTextReport"
							[placeholder]="labels.lbl_geral_pesquisar"
							(input)="searchTextReport = $event.target.value; searchReport()" />
					</div>
					<div class="table-container">
						<table>
							<thead>
								<tr>
									<th>{{ labels.lbl_geral_data }}</th>
									<th>{{ labels.lbl_analista }}</th>
									<!-- <th>{{ labels.lbl_geral_manuf_modelo }}</th> -->
									<th>{{ labels.lbl_geral_motivo }}</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngIf="filteredReport || filteredReport?.length === 0; else showAll">
									<tr class="select-bond" *ngFor="let item of filteredReport; let indexItem = index">
										<td>{{ item.date_time }}</td>
										<td>{{ item.full_name }}</td>
										<!-- <td>{{ item.model }}</td> -->
										<td>{{ item.message }}</td>
									</tr>
								</ng-container>
								<ng-template #showAll>
									<tr class="select-bond" *ngFor="let item of reportModelList; let indexItem = index">
										<td>{{ item.date_time }}</td>
										<td>{{ item.full_name }}</td>
										<!-- <td>{{ item.model }}</td> -->
										<td>{{ item.message }}</td>
									</tr>
								</ng-template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	class="mt-2 ml-2"
	*ngIf="isLoadingLabels || isLoadingModels || isLoadingManufacturers || isLoadingCiTypes || isLoadingSubtypes"
	[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
